/* eslint-disable react-hooks/exhaustive-deps */

import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import Auto from "components/AutoComplete/AutoComplete";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import MuiPhoneNumber from "material-ui-phone-number";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { addWarehouseData, getWarehouseById, updateWarehouseData } from "utils/api";
import { blank, generateDataList, getScreenRight, handleStreetAddress, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";



const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
let fetchedWarehouse;
let routePath = "/warehouse";

function AddNewWarehouse() {
  const { id } = useParams();
  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const [screenName, setScreenName] = useState("Add New Warehouse");

  const [warehouseNameErr, setWarehouseNameErr] = useState(false);
  const [warehouseCodeErr, setWarehouseCodeErr] = useState(false);
  const [contactPersonNameErr, setContactPersonNameErr] = useState(false);
  const [contactPersonNumberErr, setContactPersonNumberErr] = useState(false);
  const [streetAddressErr, setStreetAddressErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [zipCodeErr, setZipCodeErr] = useState(false);

  const [state, setState] = useState([]);
  const [country, setCountry] = useState([])
  const [disableColor, setDisableColor] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let countryData = useSelector((state) => state.countryState.countryStateMenu.country)
  let stateData = useSelector((state) => state.countryState.countryStateMenu.state)

  const [values, setValues] = React.useState({
    countryCode: "",
    warehouseName: '',
    contactPersonName: '',
    contactPersonNumber: '+61',
    warehouseCode: '',
    streetAddress: '',
    warehouseStatus: 'Active',
    city: '',
    countryId: '',
    stateId: '',
    zipCode: '',
    searchParameter: '',
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
    searchParameterList: ['warehouseName', 'warehouseCode', 'city', 'stateName', 'warehouseStatus',],
  });
  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  useEffect(() => {
    id === undefined ? setScreenName("Add New Warehouse") : setScreenName("Edit Warehouse");
    (async () => {
      getRight()
      stateListRef.current = stateData;
      countryListRef.current = countryData;
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"));
      if (id !== undefined) {
        values._id = id
        getWarehouseById(values, (data) => {
          if (data.Result_Output.length > 0) {
            fetchedWarehouse = data.Result_Output[0];
            setValues(fetchedWarehouse);
          }
        }, dispatch)
      }
    }
    )();
  }, [dispatch])

  async function getRight() {
    let right = await getScreenRight("Warehouse")
    if (right === "Full Access") setDisableColor(false)
    else setDisableColor(true)
  }

  const clearErrorStates = () => {
    setWarehouseNameErr(false);
    setContactPersonNameErr(false);
    setContactPersonNumberErr(false);
    setWarehouseCodeErr(false);
    setStreetAddressErr(false);
    setCityErr(false);
    setZipCodeErr(false);
  };

  const addWarehouse = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.warehouseName, setWarehouseNameErr) || mandateFlag;
    mandateFlag = validateField(values.contactPersonName, setContactPersonNameErr) || mandateFlag;
    mandateFlag = validateField(values.contactPersonNumber, setContactPersonNumberErr) || mandateFlag;
    mandateFlag = validateField(values.warehouseCode, setWarehouseCodeErr) || mandateFlag;
    mandateFlag = validateField(values.streetAddress, setStreetAddressErr) || mandateFlag;
    mandateFlag = validateField(values.city, setCityErr) || mandateFlag;
    mandateFlag = validateField(values.zipCode, setZipCodeErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const apiFunction = id === undefined ? addWarehouseData : updateWarehouseData;
    apiFunction(values, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  const handleStreetOnChange = (e) => {
    if (e.target.value === "") {
      setValues((prevValues) => ({
        ...prevValues,
        city: "",
        countryId: "",
        zipCode: "",
        stateId: "",
        streetAddress: "",
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: e.target.value,
      }));
    }
  };


  const setPhoneValues = (phone, country) => {


    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    console.log("phone", phone.slice(country.dialCode.length));
    values.contactPersonNumber = phone.slice(country.dialCode.length);
    values.contactPersonNumber = phone
    values.countryCode = "+" + country.dialCode;
  };


  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = (e) => {
    const inputElement = document.querySelector('.GoogleInput');
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} spacing={6}>
            <Card sx={{ boxShadow: "none" }}>
              <PageTitle screenName={screenName} />
              <MDBox pt={4} pb={3} px={3}>
                <Grid container columnSpacing={5}>
                  <Grid item xs={12} lg={3}>
                    <MDBox mb={4} xs={12}>
                      <TextField
                        type="text"
                        label="Warehouse Name"
                        variant="outlined"
                        fullWidth
                        value={values.warehouseName}
                        autoFocus={true}
                        inputProps={{
                          // pattern: "^[A-Za-z ]+$",
                          maxLength: 50
                        }}
                        onChange={handleChange("warehouseName")}
                      />
                      {warehouseNameErr ? <span style={errMsg}>Warehouse Name can't be blank</span> : ""}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="Warehouse Code"

                          variant="outlined"
                          fullWidth
                          inputProps={{
                            // pattern: "^[a-zA-Z0-9 ]+$",
                            maxLength: 10
                          }}
                          value={values.warehouseCode}
                          onChange={handleChange("warehouseCode")}
                          disabled={id !== undefined}
                        />
                        {warehouseCodeErr ? <span style={errMsg}>Warehouse Code can't be blank</span> : ""}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="Contact Person Name"
                          variant="outlined"
                          fullWidth
                          value={values.contactPersonName}
                          inputProps={{
                            pattern: "^[a-zA-Z ]+$",
                            maxLength: 30
                          }}
                          onChange={handleChange("contactPersonName")}
                        />

                        {contactPersonNameErr ? <span style={errMsg}>Contact Person Name can't be blank</span> : ""}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <MuiPhoneNumber
                          defaultCountry={"au"}
                          type="text"
                          label="Contact Person Number (Optional)"
                          variant="outlined"
                          fullWidth
                          value={values.contactPersonNumber}
                          onChange={(phone, country) => setPhoneValues(phone, country)}
                        />
                        {contactPersonNumberErr ? <span style={errMsg}>Contact Person Number can't be blank</span> : ""}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <Auto
                          onChange={handleStreetOnChange}
                          onPlaceSelected={(place, e) => handleStreetAddress(place, e, (data) => {
                            setValues((prevValues) => ({
                              ...prevValues,
                              zipCode: data.zipCode,
                              city: data.city,
                              countryId: data.countryId,
                              stateId: data.stateId,
                              streetAddress: data.streetAddress,
                              warehouseLocationLatitude: data.locationLatitude,
                              warehouseLocationLongitude: data.locationLongitude
                            }));
                          }, stateListRef, countryListRef)}
                          value={values.streetAddress} />
                        {streetAddressErr ? <span style={errMsg}>Street Address can't be blank</span> : ""}

                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="City"
                          variant="outlined"
                          fullWidth
                          disabled
                          inputProps={{
                            pattern: "^[a-zA-Z0-9 ]+$",
                            maxLength: 30
                          }}
                          value={values.city}
                          onChange={(e) => setValues({ ...values, city: e.target.value })}
                        />
                        {cityErr ? <span style={errMsg}>City can't be blank</span> : ""}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="Zip Code"
                          variant="outlined"
                          fullWidth

                          disabled
                          inputProps={{
                            pattern: "^[0-9 ]+$",
                            maxLength: 4
                          }}
                          value={values.zipCode}
                          onChange={(e) => setValues({ ...values, zipCode: e.target.value })}
                        />
                        {zipCodeErr !== "" ? <span style={errMsg}>{zipCodeErr}</span> : ""}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox mb={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Country
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ minHeight: "44.11px" }}
                          label="Country"
                          disabled
                          value={values.countryId}
                          onChange={(e) => setValues({ ...values, countryId: e.target.value })}
                        >
                          {country}
                        </Select>
                      </FormControl>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox mb={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          State
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ minHeight: "44.11px" }}
                          label="State"
                          disabled
                          value={values.stateId}
                          onChange={(e) => setValues({ ...values, stateId: e.target.value })}
                        >
                          {state}
                        </Select>
                      </FormControl>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox mb={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Warehouse Status</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ minHeight: "44.11px" }}
                          label="Warehouse Status"
                          onChange={handleChange("warehouseStatus")}
                          value={values.warehouseStatus}
                        >
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                      </FormControl>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>

          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.2}>
            <Link to={"/warehouse"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.2}>
            <MDButton
              onClick={disableColor ? blank : addWarehouse}

              variant="gradient"
              className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"}
              fullWidth
            >
              {id !== undefined ? <>Update</> : <>Save</>}

            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AddNewWarehouse;
